import React from 'react';
export function MediaMentionsSection() {
  return <section className="bg-muted py-10 sm:py-14" data-id="element-398">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-399">
        <div className="text-center mb-7" data-id="element-400">
          <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground mb-3" data-id="element-401">
            Mencionado en los principales medios
          </p>
          <div className="flex items-center justify-center gap-2" data-id="element-402">
            <span className="w-2 h-2 bg-green-500 rounded-full" data-id="element-403"></span>
            <span className="text-sm font-medium text-green-700" data-id="element-404">
              Resultados verificados por expertos
            </span>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4" data-id="element-405">
          <div className="px-5 py-2.5 rounded-full border border-border bg-card text-muted-foreground font-bold text-sm sm:text-base tracking-tight hover:border-green-200 transition-colors duration-200" data-id="element-406">
            El País
          </div>
          <div className="px-5 py-2.5 rounded-full border border-border bg-card text-muted-foreground font-bold text-sm sm:text-base tracking-tight hover:border-green-200 transition-colors duration-200" data-id="element-407">
            ¡Hola!
          </div>
          <div className="px-5 py-2.5 rounded-full border border-border bg-card text-muted-foreground font-bold text-sm sm:text-base tracking-tight hover:border-green-200 transition-colors duration-200" data-id="element-408">
            Vogue España
          </div>
          <div className="px-5 py-2.5 rounded-full border border-border bg-card text-muted-foreground font-bold text-sm sm:text-base tracking-tight hover:border-green-200 transition-colors duration-200" data-id="element-409">
            Telva
          </div>
          <div className="px-5 py-2.5 rounded-full border border-border bg-card text-muted-foreground font-bold text-sm sm:text-base tracking-tight hover:border-green-200 transition-colors duration-200" data-id="element-410">
            Woman
          </div>
        </div>
      </div>
    </section>;
}